import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getDriversSelector = createSelector(
  driver => driver.driver,
  (driversById) => getArrayOfObjectValues(driversById)
);